import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { ExternalSupportTicketResponsibleValidationSchema } from '@/features/support/external/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

interface UseUpdateExternalSupportTicketResponsibleProps {
  supportTicketId?: string
  onSuccess: (response: AxiosResponse) => void
  onError: (error: ErrorResponse) => void
}

export const useUpdateExternalSupportTicketResponsible = ({
  supportTicketId,
  onSuccess,
  onError,
}: UseUpdateExternalSupportTicketResponsibleProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateExternalSupportTicketResponsible'],
    mutationFn: async (form: ExternalSupportTicketResponsibleValidationSchema) => {
      const payload = {
        responsible_id: form.responsible?.value,
      }

      return privateAxios.put(`/support/tickets/${supportTicketId}`, { support_ticket: payload })
    },
    onSuccess,
    onError,
  })
}
